import React, { useEffect, useRef, useState } from 'react'
import useOnScreen from 'hooks/onScreen'
import { LocaleCurrency as LocaleCurrencyComponent, USD } from 'components/FormatPrice'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import StickyCartConnector, {
  ConnectorProps as StickyCartProps,
} from '../../connectors/ProductStickyCart'
import { StickyCart, Text, StickyAddToCartButton, ColumnStickyCart } from '../styles/products'
import { FOR_SALE, ORIGINAL } from '../../helpers/constants'
import MAO from './Original/MAO'
import { capitalizeString } from 'lib/helpers'
import classNames from 'classnames'

const Component = (props: StickyCartProps) => {
  const {
    artistName,
    artworkImage,
    // artworkImageAspectRatio,
    artworkTitle,
    checkMobileScreen,
    clickAddToCart,
    clickMakeAnOffer,
    currentTab,
    productPrice,
    productStatus,
    totalPriceInCentsOfSelectedOptions,
    sku,
    updateDataLayer,
    promoDiscount,
    promoCode,
  } = props
  const capitalizedArtistName = capitalizeString(artistName)
  const [isAtFooter, setIsAtFooter] = useState(false)
  const stickyRef: Record<string, any> = useRef()
  const { isSetup, isViewable, isFeatureAvailable } = useOnScreen(stickyRef)
  const discountedPrice = (1 - promoDiscount / 100) * productPrice
  // We need to Figure out the Position of REF on the Page to check if we have scrolled PAST
  const scrollBelowRef: boolean =
    stickyRef.current && stickyRef.current.getBoundingClientRect
      ? stickyRef.current.getBoundingClientRect().y < 0
      : false
  // We want a way to Show component when Mobile Screen, Passed Object, Below Component
  const isVisible = isSetup && !isViewable && checkMobileScreen && scrollBelowRef && !isAtFooter
  const thumbnailUrlBase = artworkImage.replace('-7.jpg', '')

  useEffect(() => {
    document.documentElement.style.setProperty('--sticky-bar-height', isVisible ? '100px' : '0px')
  }, [isVisible])

  // Check if the window has scrolled to the bottom
  const checkIsAtFooter = () => {
    const scrollPosition = window.scrollY + window.innerHeight
    const documentHeight = document.documentElement.scrollHeight
    const footerPosition = documentHeight - 250

    setIsAtFooter(scrollPosition > footerPosition)
  }

  useEffect(() => {
    window.addEventListener('scroll', checkIsAtFooter)

    return () => {
      window.removeEventListener('scroll', checkIsAtFooter)
    }
  }, [])

  // Not a MODERN Browser ( iOS/Safari issue ) - do NOT render
  if (!isFeatureAvailable) {
    return null
  }

  // // We need to use a smaller Image but want to keep the Aspect Ratio
  // // Let solve that by setting up the values
  // const [WIDTH, HEIGHT] = [60, 60] // Always STATIC
  // let width = HEIGHT * artworkImageAspectRatio // Dynamic Value
  // let height = HEIGHT
  // // We always want to constrain 60 x 60 and resize, nothing can be larger then 60
  // if (width > WIDTH) {
  //   width = WIDTH
  //   height = WIDTH / artworkImageAspectRatio
  // }
  // Hide if NO product or Not for Sale (reserved, sold, etc..)
  if (currentTab === ORIGINAL && productStatus !== FOR_SALE) {
    return null
  }

  return (
    <>
      <Text ref={stickyRef} data-type='sticky-text' />

      <StickyCart
        isVisible={isVisible}
        mobileWidth={770}
        data-section='sticky-cart'
        stickyBarHeight={isVisible ? 90 : 0}
      >
        <div data-type='sticky-image-text-container'>
          <img
            alt='product'
            className='lazyload'
            loading='lazy'
            data-type='image'
            src={`${thumbnailUrlBase}-22.jpg`}
            itemProp='image'
            width='60'
            height='60'
          />

          <ColumnStickyCart data-section='info'>
            <p
              className={classNames('defaultTypographyXSmall', 'defaultTextTruncate')}
              data-section='title'
            >
              {artworkTitle}
            </p>
            <p
              className={classNames('defaultTypographyXSmall', 'defaultTextTruncate')}
              data-section='artist'
            >
              {capitalizedArtistName}
            </p>

            <p
              className={classNames('defaultTypographyXSmall', 'defaultTextTruncate')}
              data-section='price'
            >
              <LocaleCurrencyComponent
                price={convertFromCentsToDollars(
                  promoDiscount !== 0
                    ? discountedPrice
                    : productPrice + totalPriceInCentsOfSelectedOptions
                )}
              />
              <USD />
            </p>
          </ColumnStickyCart>
        </div>
        <div data-type='sticky-actions'>
          <StickyAddToCartButton
            data-button='add-to-cart'
            onClick={(ev: React.SyntheticEvent<HTMLLinkElement>) => {
              ev.preventDefault()
              clickAddToCart({ sku, promoCode })
            }}
            title='Add to Cart'
          >
            <p className='defaultTypographyCtaMedium'>Add to Cart</p>
          </StickyAddToCartButton>

          {productStatus === FOR_SALE && (
            <MAO
              onClick={clickMakeAnOffer}
              sku={sku}
              updateDataLayer={updateDataLayer}
              isSticky={isVisible}
            />
          )}
        </div>
      </StickyCart>
    </>
  )
}

export default StickyCartConnector(Component)
